import * as React from 'react';
import type { CardHeaderProps, CardProps } from '@fluentui/react-components';
import { Card, CardHeader, makeStyles, shorthands, tokens } from '@fluentui/react-components';

export function ContentCard(props: CardProps) {
  const classes = useStyles();
  return <Card className={classes.root} {...props} />;
}

export function ContentCardHeader(props: CardHeaderProps) {
  const classes = useStyles();
  return <CardHeader className={classes.header} {...props} />;
}

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    ...shorthands.padding(tokens.spacingHorizontalXXL),
  },
  header: {
    ...shorthands.borderBottom(tokens.strokeWidthThin, 'solid', tokens.colorNeutralStroke2),
    paddingBottom: tokens.spacingVerticalS,
  },
});
